export default __webpack_public_path__ + "static/media/reacher_s2_001.5ede3be6.jpg";